<template>
  <div>
    <div class="row" v-if="this.data.Status === 200">
      <div class="col-12 col-lg-6 col-xl-4">
        <div class="row" v-if="this.dividends">
          <div class="col-12">
            <a
              class="p-0 btn open-ai w-100 mb-3"
              href="https://openfuture.ai/tool/savajava"
              target="_blank"
              ><img
                v-if="!this.$store.state.isLight"
                src="https://openfuture.ai/api_generate_image?product_id=649498609369b0f2c2b98e6a&amp;theme=neutral"
                loading="lazy"
                alt="SavaJava"
                class="color-button neutral-button active w-100" /><img
                v-else
                src="https://openfuture.ai/api_generate_image?product_id=649498609369b0f2c2b98e6a&amp;theme=dark"
                loading="lazy"
                alt="SavaJava"
                class="color-button neutral-button active w-100"
            /></a>
          </div>
          <div class="col-3" title="Buy me a coffee">
            <a
              style="text-decoration: none"
              href="https://www.buymeacoffee.com/savajava/membership"
              target="_blank"
            >
              <button class="btn donate-btn w-100 mb-3">
                <span class="d-none d-xl-inline-block">
                  <strong> Buy me </strong>
                </span>
                <img
                  loading="lazy"
                  src="/coffee-cup.png"
                  alt="buy me coffee"
                  class="me-1"
                />
              </button>
            </a>
          </div>
          <div
            class="col-3"
            title="Dividend Projection Calculator"
            v-if="this.dividends"
          >
            <button
              class="w-100 btn btn-secondary back-button mb-3"
              @click="openCalc"
            >
              <i class="bi bi-calculator-fill me-1"></i>
              <span class="d-none d-xl-inline-block"> Calculator </span>
            </button>
          </div>
          <div class="col-3" title="Save as PDF">
            <button
              class="w-100 btn btn-secondary back-button mb-3"
              @click="printScreen"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                id="save"
              >
                <path
                  d="M16,2H8A3,3,0,0,0,5,5V21a1,1,0,0,0,.5.87,1,1,0,0,0,1,0L12,18.69l5.5,3.18A1,1,0,0,0,18,22a1,1,0,0,0,.5-.13A1,1,0,0,0,19,21V5A3,3,0,0,0,16,2Zm1,17.27-4.5-2.6a1,1,0,0,0-1,0L7,19.27V5A1,1,0,0,1,8,4h8a1,1,0,0,1,1,1Z"
                />
              </svg>
              <span class="d-none d-xl-inline-block">Save</span>
            </button>
          </div>
          <div class="col-3" title="Back">
            <button
              class="w-100 btn btn-secondary back-button mb-5"
              @click="backToMain"
            >
              <i class="bi bi-arrow-left me-1"></i>
              <span class="d-none d-xl-inline-block">Back</span>
            </button>
          </div>
        </div>
        <div class="row" v-else>
          <div class="col-12">
            <a
              class="p-0 btn open-ai w-100 mb-3"
              href="https://openfuture.ai/tool/savajava"
              target="_blank"
              ><img
                v-if="!this.$store.state.isLight"
                src="https://openfuture.ai/api_generate_image?product_id=649498609369b0f2c2b98e6a&amp;theme=neutral"
                loading="lazy"
                alt="SavaJava"
                class="color-button neutral-button active w-100" /><img
                v-else
                src="https://openfuture.ai/api_generate_image?product_id=649498609369b0f2c2b98e6a&amp;theme=dark"
                loading="lazy"
                alt="SavaJava"
                class="color-button neutral-button active w-100"
            /></a>
          </div>
          <div class="col-4" title="Buy me a coffee">
            <a
              style="text-decoration: none"
              href="https://www.buymeacoffee.com/savajava/membership"
              target="_blank"
            >
              <button class="btn donate-btn w-100 mb-3">
                <img
                  loading="lazy"
                  src="/coffee-cup.png"
                  alt="buy me coffee"
                  class="me-1"
                />
                <span class="d-none d-xl-inline-block">
                  <strong> Buy me a coffee </strong>
                </span>
              </button>
            </a>
          </div>
          <div class="col-4" title="Save as PDF">
            <button
              class="w-100 btn btn-secondary back-button mb-3"
              @click="printScreen"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                id="save"
              >
                <path
                  d="M16,2H8A3,3,0,0,0,5,5V21a1,1,0,0,0,.5.87,1,1,0,0,0,1,0L12,18.69l5.5,3.18A1,1,0,0,0,18,22a1,1,0,0,0,.5-.13A1,1,0,0,0,19,21V5A3,3,0,0,0,16,2Zm1,17.27-4.5-2.6a1,1,0,0,0-1,0L7,19.27V5A1,1,0,0,1,8,4h8a1,1,0,0,1,1,1Z"
                />
              </svg>
              <span class="d-none d-xl-inline-block">Save as PDF</span>
            </button>
          </div>
          <div class="col-4" title="Back">
            <button
              class="w-100 btn btn-secondary back-button mb-5"
              @click="backToMain"
            >
              <i class="bi bi-arrow-left me-1"></i>
              <span class="d-none d-xl-inline-block">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="col-12 mb-3">
        <div
          class="d-block d-lg-flex justify-content-center justify-content-lg-start align-items-center mb-3"
        >
          <div class="img-wrapper mb-3 mb-lg-0 mx-lg-0 me-lg-3">
            <img
              class="logo"
              :src="logo"
              onerror="javascript:this.src='https://www.freeiconspng.com/uploads/no-image-icon-4.png'"
            />
          </div>
          <h2 class="text-center text-lg-start">
            <span class="title">
              <strong>
                {{ setStockName(this.data) }}
              </strong>
            </span>
          </h2>
        </div>
      </div>
      <div class="col-12 col-lg-6 col-xxl-4" v-if="this.dividends">
        <h3 class="text-center text-lg-start mb-3">Dividend Analysis</h3>
        <div class="table-wrapper">
          <table class="table table-hover">
            <tr v-if="isYearsMissing">
              <th>Dividend Paying Frequency</th>
              <td>
                {{
                  frequency === "inconsistent" ? frequencyFallback : frequency
                }}
              </td>
            </tr>
            <tr v-if="isYearsMissing">
              <th>Forward Annual Dividend Yield</th>
              <td>{{ this.divYield }}</td>
            </tr>
            <tr v-if="isYearsMissing">
              <th>Forward Average Annual Yield</th>
              <td>
                {{
                  setAvgYield(
                    this.data["Dividend Analysis"][
                      "All-Time Average Dividend per Payout"
                    ]
                  )
                }}
              </td>
            </tr>
            <tr>
              <th>
                All-Time Average Yield -
                {{
                  frequency === "inconsistent" ? frequencyFallback : frequency
                }}
              </th>
              <td>
                {{
                  this.data["Dividend Analysis"][
                    "All-Time Average Yield Based on Current price"
                  ]
                }}
              </td>
            </tr>
            <tr>
              <th>
                All-Time Average Dividend -
                {{
                  frequency === "inconsistent" ? frequencyFallback : frequency
                }}
              </th>
              <td>
                {{
                  this.data["Dividend Analysis"][
                    "All-Time Average Dividend per Payout"
                  ]
                }}
              </td>
            </tr>
            <tr>
              <th>Total Dividend Payment Count</th>
              <td>
                {{
                  this.data["Dividend Analysis"]["Total Dividend Payment Count"]
                }}
              </td>
            </tr>
            <tr v-if="!isYearsMissing">
              <th>Last Dividend Paid</th>
              <td>
                {{
                  this.data["Dividend Analysis"][
                    "Last Dividend Paid since(years)"
                  ].toFixed(1)
                }}
                years ago
              </td>
            </tr>
            <tr>
              <th>Current Dividend Paying Status</th>
              <td :class="{ red: !divPayingStatus, green: divPayingStatus }">
                <div class="d-flex scalable">
                  <img class="star" :src="divPayingStatusPic" />
                  {{ divPayingStatus ? "ACTIVE" : "INACTIVE" }}
                </div>
              </td>
            </tr>
            <tr v-if="isYearsMissing">
              <th>Current Dividend Payment Evaluation</th>
              <td
                :class="{
                  red: !this.isValueAvgDivYield,
                  green: this.isValueAvgDivYield,
                }"
              >
                <div class="d-flex scalable">
                  <img class="star" :src="this.avgDivVsFwdYieldPic" />
                  <span class="nowrap">{{
                    this.isValueAvgDivYield ? "ABOVE AVERAGE" : "BELOW AVERAGE"
                  }}</span>
                </div>
              </td>
            </tr>
            <tr
              v-if="
                this.priceToBookValue !== Infinity &&
                this.priceToBookValue !== 'N/A' &&
                !isNaN(this.priceToBookValue)
              "
            >
              <th>Price-to-Book Ratio (PB)</th>
              <td
                :class="{
                  green:
                    this.priceToBookValue > 0 && this.priceToBookValue <= 1,
                  orange:
                    this.priceToBookValue > 1 && this.priceToBookValue <= 10,
                  red: this.priceToBookValue < 0,
                  red2: this.priceToBookValue > 10,
                }"
              >
                <div class="d-flex scalable">
                  <img class="star" :src="this.priceToBookValuePic" />
                  {{ this.priceToBookValue.toFixed(2) }}x
                </div>
              </td>
            </tr>
            <tr>
              <th>Price-to-Earning Ratio (PE)</th>
              <td
                :class="{
                  green: this.peRatio < 10,
                  orange: this.peRatio >= 10 && this.peRatio < 20,
                  red: this.peRatio > 20,
                }"
              >
                <div class="d-flex scalable" v-if="this.peRatio !== 'No Data'">
                  <img class="star" :src="peRatioPic" />
                  {{ this.peRatio }}x
                </div>
                <div v-else>
                  {{ this.peRatio }}
                </div>
              </td>
            </tr>
            <tr
              v-if="
                debt !== 'N/A' &&
                income !== 'N/A' &&
                !isNaN(debtToIncomeRatio(this.debt, this.income))
              "
            >
              <th>Debt to Income Ratio</th>
              <td
                :class="{
                  green: debtMode < 1,
                  orange: debtMode >= 1 && debtMode < 1.5,
                  red: debtMode >= 1.5,
                }"
              >
                <div class="d-flex scalable">
                  <img class="star" :src="debtModePic" />
                  {{ debtToIncomeRatio(this.debt, this.income) }}x
                </div>
              </td>
            </tr>
            <tr v-if="!isNaN(cashToDebtRatio(this.cash, this.debt))">
              <th>Debt to Cash Ratio</th>
              <td
                :class="{
                  green: cashMode < 1,
                  orange: cashMode >= 1 && cashMode < 1.5,
                  red: cashMode >= 1.5,
                }"
              >
                <div class="d-flex scalable">
                  <img class="star" :src="cashStatusPic" />
                  {{ cashToDebtRatio(this.cash, this.debt) }}x
                </div>
              </td>
            </tr>
            <tr>
              <th>Dividend Defaults or Late Payment Strike(s)</th>
              <td
                :class="{
                  green: mode === 0,
                  orange: mode > 0 && mode <= 2,
                  red: mode >= 3,
                }"
              >
                <div class="d-flex scalable">
                  <img v-if="!isNaN(mode)" class="star" :src="star" />
                  {{ mode === 0 ? "CLEAN" : "" }}
                  {{ mode === 1 ? mode + " hit" : "" }}
                  {{ mode >= 2 ? mode + " hits" : "" }}
                  {{ isNaN(mode) ? "N/A" : "" }}
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <hr v-if="this.dividends" />
      <div class="col-12 col-lg-6 col-xxl-4">
        <h3 class="text-center text-lg-start mb-3">Fundamentals</h3>
        <div class="table-wrapper">
          <table class="table table-hover">
            <tr v-if="this.data.Fundamentals.Sector">
              <th>Sector</th>
              <td>
                {{
                  this.data.Fundamentals.Sector !== "" &&
                  this.data.Fundamentals.Sector !== "N/A" &&
                  this.data.Fundamentals.Sector !== null
                    ? this.data.Fundamentals.Sector
                    : "No Data"
                }}
              </td>
            </tr>
            <tr v-if="this.data.Fundamentals.CompanyLink">
              <th>Company Website</th>
              <td>
                <a
                  class="btn btn-secondary back-button btn-blue w-100"
                  :href="this.data.Fundamentals.CompanyLink"
                  target="_blank"
                  >Official Site</a
                >
              </td>
            </tr>
            <tr>
              <th>Current Price</th>
              <td>
                {{ dataValidityChecker(this.price, this.price) }}
              </td>
            </tr>
            <tr v-if="this.data.Fundamentals['Total Shares Outstanding']">
              <th>Market Cap</th>
              <td>
                {{
                  intToAlphaConverter(
                    this.data.Fundamentals["Total Shares Outstanding"] *
                      this.data["Last Done Price"]
                  ) !== ""
                    ? intToAlphaConverter(
                        this.data.Fundamentals["Total Shares Outstanding"] *
                          this.data["Last Done Price"]
                      )
                    : "No Data"
                }}
              </td>
            </tr>
            <tr v-if="this.data.Fundamentals['Total Shares Outstanding']">
              <th>Shares Outstanding</th>
              <td>
                {{
                  dataValidityChecker(
                    this.data.Fundamentals["Total Shares Outstanding"],
                    intToAlphaConverter(
                      this.data.Fundamentals["Total Shares Outstanding"]
                    )
                  )
                }}
              </td>
            </tr>
            <tr v-if="this.data.Fundamentals['Total Cash Balance (mrq)']">
              <th>Total Cash Balance</th>
              <td>
                {{
                  this.data.Fundamentals["Total Cash Balance (mrq)"] !== null
                    ? intToAlphaConverter(
                        alphaToIntConverter(
                          this.data.Fundamentals["Total Cash Balance (mrq)"]
                        )
                      )
                    : "No Data"
                }}
              </td>
            </tr>
            <tr v-if="this.data.Fundamentals['Book Value']">
              <th>Book Value</th>
              <td>
                {{
                  dataValidityChecker(
                    this.data.Fundamentals["Book Value"],
                    intToAlphaConverter(this.data.Fundamentals["Book Value"])
                  )
                }}
              </td>
            </tr>
            <tr v-if="this.data.Fundamentals['Net Income (ttm)']">
              <th>Net Income</th>
              <td>
                {{
                  dataValidityChecker(
                    this.data.Fundamentals["Net Income (ttm)"],
                    intToAlphaConverter(
                      this.data.Fundamentals["Net Income (ttm)"]
                    )
                  )
                }}
              </td>
            </tr>
            <tr v-if="this.data.Fundamentals['Total Debt (mrq)']">
              <th>Total Debt</th>
              <td>
                {{
                  dataValidityChecker(
                    this.data.Fundamentals["Total Debt (mrq)"],
                    intToAlphaConverter(
                      this.data.Fundamentals["Total Debt (mrq)"]
                    )
                  )
                }}
              </td>
            </tr>
            <tr
              v-if="
                !this.dividends &&
                debt !== 'N/A' &&
                income !== 'N/A' &&
                !isNaN(debtToIncomeRatio(this.debt, this.income))
              "
            >
              <th>Debt to Income Ratio</th>
              <td
                :class="{
                  green: debtMode < 1,
                  orange: debtMode >= 1 && debtMode < 1.5,
                  red: debtMode >= 1.5,
                }"
              >
                <div class="d-flex scalable">
                  <img class="star" :src="debtModePic" />
                  {{ debtToIncomeRatio(this.debt, this.income) }}x
                </div>
              </td>
            </tr>
            <tr
              v-if="
                !this.dividends && !isNaN(cashToDebtRatio(this.cash, this.debt))
              "
            >
              <th>Debt to Cash Ratio</th>
              <td
                :class="{
                  green: cashMode < 1,
                  orange: cashMode >= 1 && cashMode < 1.5,
                  red: cashMode >= 1.5,
                }"
              >
                <div class="d-flex scalable">
                  <img class="star" :src="cashStatusPic" />
                  {{ cashToDebtRatio(this.cash, this.debt) }}x
                </div>
              </td>
            </tr>
            <tr v-if="!this.dividends">
              <th>PE Ratio</th>
              <td
                :class="{
                  green: this.peRatio < 10,
                  orange: this.peRatio >= 10 && this.peRatio < 20,
                  red: this.peRatio > 20,
                }"
              >
                <div class="d-flex scalable" v-if="this.peRatio !== 'No Data'">
                  <img class="star" :src="peRatioPic" />
                  {{ this.peRatio }}x
                </div>
                <div v-else>
                  {{ this.peRatio }}
                </div>
              </td>
            </tr>
            <tr
              v-if="
                !this.dividends &&
                this.priceToBookValue !== Infinity &&
                this.priceToBookValue !== 'N/A' &&
                !isNaN(this.priceToBookValue)
              "
            >
              <th>PB Ratio</th>
              <td
                :class="{
                  green:
                    this.priceToBookValue > 0 && this.priceToBookValue <= 1,
                  orange:
                    this.priceToBookValue > 1 && this.priceToBookValue <= 10,
                  red: this.priceToBookValue < 0,
                  red2: this.priceToBookValue > 10,
                }"
              >
                <div class="d-flex scalable">
                  <img class="star" :src="this.priceToBookValuePic" />
                  {{ this.priceToBookValue.toFixed(2) }}x
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="col-12" v-if="!this.dividends">
        <h4 class="remark text-center text-lg-start my-3">
          {{ setStockName(this.data, "right") }}
          never paid a dividend.
        </h4>
      </div>
      <hr v-if="this.dividends" />
      <div class="col-12 col-lg-6 col-xxl-4" v-if="this.dividends">
        <h3 class="text-center text-lg-start mb-3">Dividend History</h3>
        <div class="table-wrapper vertical">
          <table class="table table-hover table-vertical">
            <thead>
              <tr>
                <th>Date Announcement</th>
                <th>Dividend Amount</th>
              </tr>
            </thead>
            <tbody
              v-for="dividend in this.dividendHistory"
              :key="dividend.id"
              :id="dividend.id"
            >
              <tr>
                <td>{{ dividend["Annoucement Date"] }}</td>
                <td>{{ dividend["Dividend Amount"] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-12 col-lg-6 col-xl-4">
        <button
          class="w-100 btn btn-secondary back-button mb-5"
          @click="backToMain"
        >
          <i class="bi bi-arrow-left"></i> Back
        </button>
      </div>
      <div class="col-12">
        <invalid-stocks
          :data="this.data.counter"
          :error="this.error"
        ></invalid-stocks>
      </div>
    </div>
  </div>
  <transition mode="out-in" name="pop" appear>
    <Modal v-if="this.$store.getters.calcIsOpen">
      <div class="form-input-group text-center text-lg-start">
        <h5 class="mb-4">
          <strong>
            {{ setStockName(this.data, "left") }}
          </strong>
        </h5>
      </div>
      <div class="form-input-group">
        <h5 class="mb-3">
          <strong>New Units</strong>
        </h5>
      </div>
      <div class="form-input-group">
        <button
          class="btn btn-secondary back-button btn-blue w-100 mb-3"
          @click="useCurrPrice = !useCurrPrice"
        >
          <i class="bi bi-currency-dollar"></i>&nbsp;Use
          {{ useCurrPrice ? "Custom Price" : "Current Price" }}
        </button>
      </div>
      <transition mode="out-in" name="pop" appear>
        <div class="form-input-group" v-if="!useCurrPrice">
          <input
            v-model.trim="customPrice"
            type="number"
            class="form-control mb-3"
            placeholder="Enter new purchase price.."
            min="0.01"
            step="0.01"
            required
          />
        </div>
      </transition>
      <div class="form-input-group">
        <input
          v-model.trim="newUnitsToBuy"
          type="number"
          class="form-control mb-3"
          placeholder="Total units to be purchased.."
          min="1"
          required
        />
      </div>

      <div class="form-input-group">
        <select class="form-select" v-model.trim="taxPercentage" required>
          <option selected disabled value="">Tax deduction (%)</option>
          <option value="0">0%</option>
          <option value="0.37">37%</option>
          <option value="0.35">35%</option>
          <option value="0.32">32%</option>
          <option value="0.3">30%</option>
          <option value="0.24">24%</option>
          <option value="0.22">22%</option>
          <option value="0.12">12%</option>
          <option value="0.1">10%</option>
        </select>
      </div>
      <div class="form-input-group">
        <hr class="line mt-4 my-3" />
      </div>
      <div class="form-input-group">
        <h5 class="mb-3">
          <strong>Existing Units</strong>
        </h5>
      </div>
      <div class="form-input-group">
        <button
          class="btn btn-secondary back-button btn-blue w-100 mb-3"
          @click="showExistingHolder"
        >
          <i class="bi bi-cash-coin"></i>&nbsp;
          {{ existingHolder ? "New Purchase" : "Existing Holdings" }}
        </button>
      </div>
      <transition mode="out-in" name="pop" appear>
        <div v-if="existingHolder">
          <div class="form-input-group">
            <input
              v-model.trim="existingUnits"
              type="number"
              class="form-control mb-3"
              placeholder="Existing units (if any).."
              min="0"
            />
          </div>
          <div class="form-input-group">
            <input
              v-model.trim="existingPrice"
              type="number"
              class="form-control mb-3"
              placeholder="Existing avg price (if any).."
              step="0.01"
              min="0.00"
            />
          </div>
        </div>
      </transition>
      <div class="form-input-group">
        <hr class="line mt-0 my-3" />
      </div>
      <div class="form-input-group">
        <h5
          :class="
            newUnitsToBuy !== null || existingUnits !== null ? 'mb-3' : ''
          "
        >
          <strong>Projections</strong>
        </h5>
      </div>
      <div
        class="table-wrapper table-responsive"
        v-if="newUnitsToBuy !== null || existingUnits !== null"
      >
        <table class="table table-hover">
          <tr v-if="frequency !== 'Annually'">
            <th>
              {{ frequency === "inconsistent" ? frequencyFallback : frequency }}
              Dividend (nett)
            </th>
            <td>
              <strong>{{
                newUnitsToBuy === null
                  ? 0
                  : this.currency + getFlexibleDividend().toFixed(2)
              }}</strong>
            </td>
          </tr>
          <transition mode="out-in" name="pop" appear>
            <tr>
              <th>Annual Dividend (nett)</th>
              <td>
                <strong>{{
                  newUnitsToBuy === null
                    ? 0
                    : this.currency + getAnnualDividend().toFixed(2)
                }}</strong>
              </td>
            </tr>
          </transition>
          <transition mode="out-in" name="pop" appear>
            <tr>
              <th>New Purchase Amount:</th>
              <td>
                <strong>{{
                  newUnitsToBuy === null
                    ? 0
                    : this.currency +
                      (
                        (this.useCurrPrice
                          ? this.dataValidityChecker(this.price, this.price)
                          : this.customPrice) * newUnitsToBuy
                      ).toFixed(2)
                }}</strong>
              </td>
            </tr>
          </transition>
          <transition mode="out-in" name="pop" appear>
            <tr v-if="existingHolder">
              <th>Total Units</th>
              <td>
                <strong>{{
                  existingUnits === null && existingPrice === null
                    ? 0
                    : existingUnits + newUnitsToBuy
                }}</strong>
              </td>
            </tr>
          </transition>
          <transition mode="out-in" name="pop" appear>
            <tr v-if="existingHolder">
              <th>Total Purchase Amount</th>
              <td>
                <strong>{{
                  existingUnits === null && existingPrice === null
                    ? 0
                    : this.currency +
                      (
                        (this.useCurrPrice
                          ? this.dataValidityChecker(this.price, this.price)
                          : this.customPrice) *
                          newUnitsToBuy +
                        existingPrice * existingUnits
                      ).toFixed(2)
                }}</strong>
              </td>
            </tr>
          </transition>
          <transition mode="out-in" name="pop" appear>
            <tr v-if="existingHolder">
              <th>New Average Price</th>
              <td>
                <strong>{{
                  existingUnits === null && existingPrice === null
                    ? 0
                    : this.currency +
                      (
                        ((this.useCurrPrice
                          ? this.dataValidityChecker(this.price, this.price)
                          : this.customPrice) *
                          newUnitsToBuy +
                          existingPrice * existingUnits) /
                        (existingUnits + newUnitsToBuy)
                      ).toFixed(2)
                }}</strong>
              </td>
            </tr>
          </transition>
          <tr>
            <th>Yield on Purchase</th>
            <td>
              <strong>{{ yieldOnPurchase() }}%p.a.</strong>
            </td>
          </tr>
        </table>
      </div>
    </Modal>
  </transition>
</template>
<script>
import InvalidStocks from "./InvalidStocks.vue";
import Modal from "../components/UI/Modal.vue";
export default {
  props: ["error"],
  components: {
    InvalidStocks,
    Modal,
  },
  data() {
    return {
      data: [],
      logo: "",
      dividends: false,
      isYearsMissing: false,
      dividendHistory: [],
      status: "",
      divYield: "",
      totalDiv: "",
      star: "",
      mode: "",
      divPayingStatus: false,
      divPayingStatusPic: "",
      debtPayingStatusPic: "",
      frequency: "",
      serverResponse: null,
      frequencyValues: {
        Monthly: 12,
        Quarterly: 4,
        "Bi-Annually": 2,
        Annually: 1,
      },
      frequencyFallback: "",
      debt: "",
      debtMode: "",
      income: "",
      cash: "",
      cashMode: "",
      cashStatusPic: "",
      starIcon: "/star.png",
      warningIcon: "/warning.png",
      dangerIcon: "/danger.png",
      avgDivYield: "",
      avgDivVsFwdYieldPic: "",
      isValueAvgDivYield: false,
      priceToBookValue: "",
      priceToBookValuePic: "",
      peRatio: "",
      peRatioPic: "",
      existingHolder: false,
      newUnitsToBuy: null,
      taxPercentage: "",
      existingUnits: null,
      existingPrice: null,
      useCurrPrice: true,
      customPrice: null,
      currency: null,
      stockName: null,
    };
  },
  created() {
    this.getData();
    this.setDivYield();
    this.isError();
  },
  mounted() {
    this.metaData();
  },
  updated() {
    this.isError();
  },
  computed: {
    checkIsError() {
      return this.$store.getters.isError.error;
    },
  },
  methods: {
    printScreen() {
      console.log("print clicked");
      return window.print();
    },
    setStockName(data, mod = undefined) {
      switch (mod) {
        case "right":
          if (data["Counter"].includes("(")) {
            return (this.stockName = data["Counter"]
              .split("(")[1]
              .replace(")", ""));
          }
          return (this.stockName = data["Counter"].split(" - ")[0]);
        case "left":
          if (data["Counter"].includes("(")) {
            return (this.stockName = data["Counter"].split("(")[0]);
          }
          return (this.stockName = data["Counter"].split(" - ")[1]);
        default:
          if (data["Counter"].includes("(")) {
            return (this.stockName = data["Counter"]);
          }
          return (this.stockName = data["Counter"]);
      }
    },
    yieldOnPurchase() {
      let totalAmount =
        (this.useCurrPrice
          ? this.dataValidityChecker(this.price, this.price)
          : this.customPrice) *
          this.newUnitsToBuy +
        this.existingPrice * this.existingUnits;
      let annualDividend = this.getAnnualDividend();
      return ((annualDividend / totalAmount) * 100).toFixed(2);
    },
    getFlexibleDividend() {
      return (
        (1 - this.taxPercentage) *
        (this.newUnitsToBuy + this.existingUnits) *
        parseFloat(
          this.$store.getters.loadData["Dividend History"][0]["Dividend Amount"]
        )
      );
    },
    getAnnualDividend() {
      let netDividend =
        (1 - this.taxPercentage) *
        (this.newUnitsToBuy + this.existingUnits) *
        parseFloat(
          this.$store.getters.loadData["Dividend History"][0]["Dividend Amount"]
        );

      switch (this.frequency) {
        case "Quarterly":
          return netDividend * 4;
        case "Monthly":
          return netDividend * 12;
        case "Bi-Annually":
          return netDividend * 2;
        case "Annually":
        default:
          return netDividend;
      }
    },
    showExistingHolder() {
      return (this.existingHolder = !this.existingHolder);
    },
    openCalc() {
      let body = document.querySelector("body");
      this.$store.dispatch("openCalc", true);
      body.classList.toggle("fixed");
    },
    isError() {
      this.serverResponse = this.$store.getters.isError;
    },
    dataValidityChecker(a, b) {
      return a !== null && a !== "" && !isNaN(a) ? b : "No Data";
    },
    intToAlphaConverter(num) {
      if (num === null) return;
      const length = num.toString().length;
      if (length >= 3 && length < 7) {
        return (num / 1000).toFixed(2).toString().replace(".00", "") + "K";
      }
      if (length >= 7 && length < 10) {
        return (num / 1000000).toFixed(2).toString().replace(".00", "") + "M";
      }
      if (length >= 10 && length < 13) {
        return (
          (num / 1000000000).toFixed(2).toString().replace(".00", "") + "B"
        );
      }
      if (length >= 13 && length < 15) {
        return (
          (num / 1000000000000).toFixed(2).toString().replace(".00", "") + "T"
        );
      }
    },
    alphaToIntConverter(item) {
      if (item === null) return;
      const val = item.toUpperCase();
      const value = parseFloat(
        val.replace("K", "").replace("M", "").replace("B", "").replace("T", "")
      );

      if (val.includes("K")) {
        return value * 1000;
      }

      if (val.includes("M")) {
        return value * 1000000;
      }

      if (val.includes("B")) {
        return value * 1000000000;
      }

      if (val.includes("T")) {
        return value * 1000000000000;
      }

      return "N/A";
    },
    debtToIncomeRatio(debt, income) {
      return debt / income < 0 ? "N/A" : (debt / income).toFixed(2);
    },
    cashToDebtRatio(cash, debt) {
      return !isNaN(this.alphaToIntConverter(cash)) && !isNaN(debt)
        ? (debt / this.alphaToIntConverter(cash)).toFixed(2)
        : "N/A";
    },
    numberFormatter(num) {
      return new Intl.NumberFormat().format(num);
    },
    getData() {
      this.data = this.$store.getters.loadData;
      if (this.data.Status === 200) {
        this.dividends = this.data["Stock Type"] === "Dividend";
        this.logo = this.$store.getters.loadData["Company Logo"];
        this.currency = this.$store.getters.loadData.Currency;
        this.debt =
          this.data.Fundamentals["Total Debt (mrq)"] === null
            ? "N/A"
            : this.data.Fundamentals["Total Debt (mrq)"];
        this.sharesOutstanding =
          this.data.Fundamentals["Total Shares Outstanding"] === null
            ? "N/A"
            : this.data.Fundamentals["Total Shares Outstanding"];
        this.income =
          this.data.Fundamentals["Net Income (ttm)"] === null
            ? "N/A"
            : this.data.Fundamentals["Net Income (ttm)"];
        this.cash =
          this.data.Fundamentals["Total Cash Balance (mrq)"] === null
            ? "N/A"
            : this.data.Fundamentals["Total Cash Balance (mrq)"];
        this.price =
          this.data["Last Done Price"] === null
            ? null
            : this.data["Last Done Price"].toFixed(2);

        this.priceToBookValue =
          this.data["Last Done Price"] /
            (this.data.Fundamentals["Book Value"] / this.sharesOutstanding) <
          0
            ? "N/A"
            : this.data["Last Done Price"] /
              (this.data.Fundamentals["Book Value"] / this.sharesOutstanding);
        this.peRatio =
          this.data.Fundamentals["Trailing PE"] !== "" &&
          this.data.Fundamentals["Trailing PE"] !== "N/A" &&
          this.data.Fundamentals["Trailing PE"] !== null
            ? this.data.Fundamentals["Trailing PE"]
            : "No Data";

        this.debtMode = this.debtToIncomeRatio(this.debt, this.income);
        this.cashMode = this.cashToDebtRatio(this.cash, this.debt);

        if (this.peRatio < 10) {
          this.peRatioPic = this.starIcon;
        } else if (this.peRatio >= 10 && this.peRatio < 20) {
          this.peRatioPic = this.warningIcon;
        } else {
          this.peRatioPic = this.dangerIcon;
        }

        if (this.priceToBookValue > 0 && this.priceToBookValue <= 1) {
          this.priceToBookValuePic = this.starIcon;
        } else if (this.priceToBookValue > 1 && this.priceToBookValue <= 10) {
          this.priceToBookValuePic = this.warningIcon;
        } else {
          this.priceToBookValuePic = this.dangerIcon;
        }

        if (this.cashMode < 1) {
          this.cashStatusPic = this.starIcon;
        } else if (this.cashMode >= 1 && this.cashMode < 1.5) {
          this.cashStatusPic = this.warningIcon;
        } else {
          this.cashStatusPic = this.dangerIcon;
        }

        if (this.debtMode < 1) {
          this.debtModePic = this.starIcon;
        } else if (this.debtMode >= 1 && this.debtMode < 1.5) {
          this.debtModePic = this.warningIcon;
        } else {
          this.debtModePic = this.dangerIcon;
        }
      }

      if (this.data.Status === 200 && this.data["Stock Type"] === "Dividend") {
        this.dividendHistory = this.data["Dividend History"];
        this.mode = +this.data["Dividend Suspension Count"];
        this.divPayingStatus =
          this.data["Dividend Analysis"]["Actively Paying"];
        this.frequency = this.data["Dividend Frequency"].trim();
        this.avgDivYield = this.setAvgYield(
          this.data["Dividend Analysis"]["All-Time Average Dividend per Payout"]
        );
        this.isValueAvgDivYield =
          +this.setDivYield().replace("%", "") >
          +this.setAvgYield(
            this.data["Dividend Analysis"][
              "All-Time Average Dividend per Payout"
            ]
          ).replace("%", "");
        this.isYearsMissing =
          this.$store.getters.loadData["Dividend Analysis"]["Actively Paying"];

        if (this.isValueAvgDivYield) {
          this.avgDivVsFwdYieldPic = this.starIcon;
        } else {
          this.avgDivVsFwdYieldPic = this.dangerIcon;
        }

        if (this.mode === 0) {
          this.star = this.starIcon;
        } else if (this.mode > 0 && this.mode <= 2) {
          this.star = this.warningIcon;
        } else {
          this.star = this.dangerIcon;
        }

        if (this.divPayingStatus) {
          return (this.divPayingStatusPic = this.starIcon);
        } else {
          return (this.divPayingStatusPic = this.dangerIcon);
        }
      }

      if (this.data.Status === 404) {
        this.status = this.data.status;
      }
    },
    setAvgYield(val) {
      if (this.$store.getters.loadData["Dividend Frequency"] === "Monthly") {
        this.totalAvgDiv = parseFloat(val) * 12;
      }
      if (this.$store.getters.loadData["Dividend Frequency"] === "Quarterly") {
        this.totalAvgDiv = parseFloat(val) * 4;
      }
      if (
        this.$store.getters.loadData["Dividend Frequency"] === "Bi-Annually"
      ) {
        this.totalAvgDiv = parseFloat(val) * 2;
      }
      if (this.$store.getters.loadData["Dividend Frequency"] === "Annually") {
        this.totalAvgDiv = parseFloat(val) * 1;
      }

      return (this.divAvgYield =
        (
          (this.totalAvgDiv / this.$store.getters.loadData["Last Done Price"]) *
          100
        ).toFixed(2) + "%");
    },
    setDivYield() {
      if (this.$store.getters.loadData["Dividend Frequency"] === "Monthly") {
        this.totalDiv =
          parseFloat(
            this.$store.getters.loadData["Dividend History"][0][
              "Dividend Amount"
            ]
          ) * 12;
      }
      if (this.$store.getters.loadData["Dividend Frequency"] === "Quarterly") {
        this.totalDiv =
          parseFloat(
            this.$store.getters.loadData["Dividend History"][0][
              "Dividend Amount"
            ]
          ) * 4;
      }
      if (
        this.$store.getters.loadData["Dividend Frequency"] === "Bi-Annually"
      ) {
        this.totalDiv =
          parseFloat(
            this.$store.getters.loadData["Dividend History"][0][
              "Dividend Amount"
            ]
          ) * 2;
      }
      if (this.$store.getters.loadData["Dividend Frequency"] === "Annually") {
        this.totalDiv =
          parseFloat(
            this.$store.getters.loadData["Dividend History"][0][
              "Dividend Amount"
            ]
          ) * 1;
      }
      if (
        this.$store.getters.loadData["Dividend Frequency"] === "Inconsistent"
      ) {
        const differenceInMonths =
          (new Date(
            this.$store.getters.loadData["Dividend History"][0][
              "Annoucement Date"
            ]
          ) -
            new Date(
              this.$store.getters.loadData["Dividend History"][1][
                "Annoucement Date"
              ]
            )) /
          (1000 * 60 * 60 * 24 * 7 * 4);

        const frequencyFinal = function () {
          if (differenceInMonths) {
            if (differenceInMonths > 2 && differenceInMonths < 6) {
              return "Quarterly";
            }
            if (differenceInMonths === 2) {
              return "Bi-Annually";
            }
            if (differenceInMonths === 12) {
              return "Monthly";
            }
            if (differenceInMonths === 1) {
              return "Annually";
            }
            return "Inconsistent";
          }
        };

        this.frequencyFallback = frequencyFinal();

        this.totalDiv =
          parseFloat(
            this.$store.getters.loadData["Dividend History"][0][
              "Dividend Amount"
            ]
          ) * this.frequencyValues[frequencyFinal()];
      }
      return (this.divYield =
        (
          (this.totalDiv / this.$store.getters.loadData["Last Done Price"]) *
          100
        ).toFixed(2) + "%");
    },
    backToMain() {
      this.data = [];
      this.$store.commit("loadData", []);
      this.$store.dispatch("isHomePage", true);

      // Resetting header/metadata tags
      document.getElementsByTagName("meta")["description"].content =
        "Dividend stock's credit score at your fingertips";
      document.querySelector("link[rel=icon]").href = "/favicon.png";
      document.title = `SavaJava Dividend Stocks Information and Analysis Screener`;

      if (this.error) {
        this.$store.dispatch("isError", {
          error: false,
          status: null,
        });
        return this.$store.dispatch("dataLoaded", false);
      }
      return this.$store.dispatch("dataLoaded", false);
    },
    metaData() {
      document.getElementsByTagName("meta")["description"].content =
        this.$store.getters.loadData.Status === 200
          ? `Showing dividend details of ${this.data["Counter"].replaceAll(
              ",",
              ""
            )}`
          : `Invalid search parameter detected, as no record found for ${this.data.counter}!`;
      document.querySelector("link[rel=icon]").href =
        this.$store.getters.loadData.Status === 200
          ? this.logo
          : "/favicon.png";
      document.title =
        this.$store.getters.loadData.Status === 200
          ? `Search Result for ${this.data["Counter"].replaceAll(",", "")}`
          : `Search for ${this.data.counter} not found!`;
    },
  },
};
</script>
<style scoped>
span.title {
  color: #3bbafa;
}

img.star {
  width: 35px;
  margin-right: 5px;
}

div.d-flex {
  justify-content: center;
  align-items: center;
}

.nowrap {
  white-space: nowrap;
}

.green {
  color: rgba(0, 128, 0, 0.737);
  transition: all 0.1s ease-in;
}

.red,
.red2 {
  color: #fd1100;
  transition: all 0.1s ease-in;
}

.orange {
  color: rgba(221, 109, 5, 0.93);
  transition: all 0.1s ease-in;
}

.scalable {
  transition: all 0.1s ease-in-out;
}
.scalable:hover {
  transform: scale(1.15);
}

div.alert.alert-primary {
  background-color: #cfe2ff;
}

div.alert.alert-primary p,
div.alert.alert-primary h5 {
  color: #012758;
}

.remark {
  color: #f5a5a5;
}

.table-wrapper {
  border-radius: 15px;
  box-shadow: 0px 1px 10px 0px rgba(255, 255, 255, 0.2);
  width: 100%;
  background: transparent;
  overflow: hidden;
}

table {
  color: #333;
  background-color: #fff;
  transition: all 0.3s ease-in-out;
  margin-bottom: 0;
}

.table-wrapper {
  transition: all 0.3s ease-out;
}

.table-wrapper:hover {
  transform: scale(1.05);
}

.table-wrapper.vertical:hover {
  transform: translateY(calc(3% - 20px)) scale(1.05);
}

table.table-vertical,
table td {
  text-align: center;
  font-weight: bold;
}

table.table-vertical th {
  border: 1px solid #003479 !important;
}

.table > :not(:last-child) > :last-child > * {
  border: 1px solid transparent;
}

.table > :not(caption) > * > * {
  box-shadow: unset;
  padding: 2px 5px;
}

th,
td {
  padding: 5px;
}

th {
  background-color: #003479 !important;
  color: #ddd;
}

tr:first-child th,
.table-vertical th:first-child {
  border-radius: 12px 0px 0px 0px;
}

tr:last-child th,
.table-vertical td:first-child {
  border-radius: 0px 0px 0px 12px;
}

.table-vertical th:last-child {
  border-radius: 0px 12px 0px 0px;
}

hr:not([size]) {
  height: 5px;
  color: #ccc;
  margin: 30px auto;
}

.img-wrapper {
  border-radius: 50%;
  padding: 20px;
  width: fit-content;
  margin: 0 auto;
  background: #f5f5f5;
  transition: all 0.3s ease-in-out;
}
img.logo {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  transition: all 0.3s ease-in-out;
}

img.logo:hover {
  transform: scale(1.3);
}

.back-button.btn-blue {
  color: #012758;
}

.btn svg {
  width: 24px;
  height: 20px;
  fill: #333;
  margin-bottom: 3px;
  margin-right: 2px;
}

/* Light Mode */
.light .back-button.btn-blue {
  color: #ccc;
  background: #012758;
}

.light span.title {
  color: #012758;
}

.light .remark {
  color: #940f0f;
}

.light table {
  background-color: #fff;
  box-shadow: 0px 1px 10px 0px rgb(0 0 0 / 20%);
}

.light th {
  background-color: #003479 !important;
  color: #ddd;
}

.light hr:not([size]) {
  color: #333;
}

.light .img-wrapper {
  background-color: transparent;
  padding: 0 0 15px 0;
}

.light img.logo {
  transform: scale(1.2) rotateZ(360deg);
}

.light img.logo:hover {
  transform: scale(1.6) rotateZ(360deg);
}

.light .table-wrapper {
  box-shadow: 0px 1px 4px 0px rgba(0 0 0, 0.2);
}

.light .btn svg {
  fill: #fff;
}

@media screen and (min-width: 992px) {
  .light .img-wrapper {
    background-color: transparent;
    padding: 0 10px 5px 15px;
  }
}
</style>
